import { render, staticRenderFns } from "./BaseMultiselectDropdown.vue?vue&type=template&id=bb444ee0&"
import script from "./BaseMultiselectDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseMultiselectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultiselectDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports